module.exports = __webpack_public_path__ + "1959affd2b98bea1f5be95d21153bee4.png";